module.exports = __webpack_public_path__ + "assets/img/tit4.665f28db.png";